import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import { initAuthStateListener } from "./utils/auth";
import modalPlugin from "./plugin/modalPlugin";

// PrimeVue 3 설정
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersist);

app.use(pinia);
app.use(router);
app.use(modalPlugin);
app.use(PrimeVue, {
  unstyled: false,
  pt: {},
  ripple: true,
});
app.mount("#app");

// Firebase Auth 상태 리스너 초기화
initAuthStateListener();

window.Kakao.init("35694cda9502395d5f9eaa040ab792b2");
